import { useStyles } from "./GamingLoading.style";
import { StaticImage } from "../StaticImage";
import { assetsImages } from "../../../models/theme";

const GamingLoading: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <StaticImage
        src={assetsImages.loadingLogo["1x"]}
        src2x={assetsImages.loadingLogo["2x"]}
        src3x={assetsImages.loadingLogo["3x"]}
        alt="gaming-loading"
        width={37}
        height={38}
      />
    </div>
  );
};

export default GamingLoading;
